<template>
    <div>
        <h2 class="mb-6">User access rights request form</h2>
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            Request type
        </v-alert>
        <v-card>
            <v-card-text>
                <v-container class="pb-0 pt-0">
                    <v-row class="pb-0 pt-0">
                        <v-col
                            md="3"
                            sm="6"
                            xs="12"
                            v-for="(item, key) in selected_type"
                            :key="key"
                            class="mb-0 mt-0 pb-0"
                        >
                            <v-radio-group v-model="radiocheckone">
                                <v-radio
                                    color="green"
                                    :label="item.name"
                                    :value="item.value"
                                >
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card v-if="radiocheckone != ''">
            <v-alert dense border="bottom" type="primary" icon="mdi-information"
                >Employee Information
            </v-alert>
            <v-card-text class="pb-0 pt-0">
                <v-container class="pb-0 pt-0">
                    <v-row>
                        <v-col md="3" sm="6" xs="12">
                            <v-text-field
                                class="caption"
                                label="Empno"
                                :rules="[(v) => !!v || 'Empno is required']"
                            ></v-text-field>
                        </v-col>
                        <v-col md="3" sm="6" xs="12">
                            <v-text-field
                                class="caption"
                                label="First name"
                                :rules="[
                                    (v) => !!v || 'First name is required',
                                ]"
                            ></v-text-field>
                        </v-col>
                        <v-col md="3" sm="6" xs="12">
                            <v-text-field
                                class="caption"
                                label="Last name"
                                :rules="[(v) => !!v || 'Last name is required']"
                            ></v-text-field>
                        </v-col>
                        <v-col md="3" sm="6" xs="12">
                            <v-text-field
                                class="caption"
                                label="Department"
                                :rules="[
                                    (v) => !!v || 'Department is required',
                                ]"
                            ></v-text-field>
                        </v-col>
                        <v-col md="3" sm="6" xs="12">
                            <v-text-field
                                class="caption"
                                label="Position"
                                :rules="[(v) => !!v || 'Position is required']"
                            ></v-text-field>
                        </v-col>
                        <v-col md="3" sm="6" xs="12">
                            <v-text-field
                                class="caption"
                                label="Cost Center"
                                :rules="[
                                    (v) => !!v || 'CostCenter is required',
                                ]"
                            ></v-text-field>
                        </v-col>
                        <v-col md="3" sm="6" xs="12">
                            <v-select
                                :items="selected_timeatt"
                                item-text="name"
                                item-value="value"
                                label="Time Att. Permission"
                                required
                            ></v-select>
                        </v-col>
                        <v-col md="3" sm="6" xs="12">
                            <v-select
                                :items="selected_timeranged"
                                item-text="name"
                                item-value="value"
                                label="Time Att. Range"
                                required
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card v-if="radiocheckone != ''">
            <v-alert dense border="bottom" type="primary" icon="mdi-information"
                >Permission
            </v-alert>
            <v-card-text class="pb-0 pt-0">
                <v-container class="pb-0 pt-0">
                    <v-row>
                        <v-col
                            cols="4"
                            v-for="(item, key) in selected_permission"
                            :key="key"
                        >
                            <v-checkbox
                                v-model="checkboxrequest"
                                :label="item.name"
                                :value="item.value"
                                @change="chooserequest(item.value)"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card v-if="radiocheckone != '' && checkboxemail == true">
            <v-alert dense border="bottom" type="primary" icon="mdi-gmail"
                >Email
            </v-alert>
            <v-card-text class="pb-0 pt-0">
                <v-container class="pb-0">
                    <v-row>
                        <v-col md="4" xs="12">
                            <v-text-field
                                class="caption"
                                placeholder="Ex : example@acacia-it.co.th"
                                label="E-Mail"
                                :rules="[
                                    (v) => !!v || 'E-Mail Name is required',
                                ]"
                            ></v-text-field>
                        </v-col>
                        <v-col md="4" xs="12">
                            <v-text-field
                                class="caption"
                                placeholder="Ex : example@acacia-it.co.th"
                                label="E-Mail Group"
                                :rules="[
                                    (v) => !!v || 'E-Mail Group is required',
                                ]"
                            ></v-text-field>
                        </v-col>
                        <v-col md="4" xs="12">
                            <v-checkbox
                                v-model="checklearnerid"
                                label="Request Learner ID ? (เฉพาะช่าง)"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card v-if="radiocheckone != '' && checkboxbuilding == true">
            <v-alert
                dense
                border="bottom"
                type="primary"
                icon="mdi-office-building"
                >Working Location Access
            </v-alert>
            <v-card-text class="pb-0 pt-0">
                <v-container class="pb-0">
                    <v-row>
                        <v-col
                            cols="4"
                            v-for="(item, key) in selected_location"
                            :key="key"
                            class="pt-0 pb-0"
                        >
                            <v-checkbox
                                class="pt-0"
                                v-model="checkboxworkstation"
                                :label="item.name"
                                :value="item.value"
                                @change="chooseworkstation(item.value)"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" v-if="checkboxsrifuengfung">
                            <hr class="mb-8" />
                            <h2 class="mb-6">Srifuengfung Bldg. (Rama 4)</h2>
                            <h3>Access Area</h3>
                            <v-row class="mb-6">
                                <v-col
                                    cols="4"
                                    v-for="(item, key) in selected_sff_area"
                                    :key="key"
                                    class="pt-0 pb-0"
                                >
                                    <v-checkbox
                                        class="pt-0"
                                        v-model="checkboxrequest"
                                        :label="item.name"
                                        :value="item.value"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <h3>Access Hours</h3>
                            <v-row>
                                <v-col
                                    cols="4"
                                    v-for="(item, key) in selected_access_hour"
                                    :key="key"
                                    class="pt-0 pb-0"
                                >
                                    <v-checkbox
                                        class="pt-0 "
                                        v-model="checkboxrequest"
                                        :label="item.name"
                                        :value="item.value"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" v-if="checkboxdhlrama3">
                            <hr class="mb-8" />
                            <h2 class="mb-6">DHL Bldg. (Rama 3)</h2>
                            <h3>Access Area</h3>
                            <v-row class="mb-6">
                                <v-col
                                    cols="4"
                                    v-for="(item, key) in selected_dhl_area"
                                    :key="key"
                                    class="pt-0 pb-0"
                                >
                                    <v-checkbox
                                        class="pt-0"
                                        v-model="checkboxrequest"
                                        :label="item.name"
                                        :value="item.value"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <h3>Access Hours</h3>
                            <v-row>
                                <v-col
                                    cols="4"
                                    v-for="(item, key) in selected_access_hour"
                                    :key="key"
                                    class="pt-0 pb-0"
                                >
                                    <v-checkbox
                                        class="pt-0 "
                                        v-model="checkboxrequest"
                                        :label="item.name"
                                        :value="item.value"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" v-if="checkboxsvc">
                            <hr class="mb-8" />
                            <h2 class="mb-6">SVC / WFH / HUB</h2>
                            <h3>Access Area</h3>
                            <v-row class="mb-6">
                                <v-col
                                    cols="4"
                                    v-for="(item, key) in selected_svc_area"
                                    :key="key"
                                    class="pt-0 pb-0"
                                >
                                    <v-checkbox
                                        class="pt-0"
                                        v-model="checkboxrequest"
                                        :label="item.name"
                                        :value="item.value"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <h3>Access Hours</h3>
                            <v-row>
                                <v-col
                                    cols="4"
                                    v-for="(item, key) in selected_access_hour"
                                    :key="key"
                                    class="pt-0 pb-0"
                                >
                                    <v-checkbox
                                        class="pt-0 "
                                        v-model="checkboxrequest"
                                        :label="item.name"
                                        :value="item.value"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card v-if="radiocheckone != '' && checkboxaccess == true">
            <v-alert dense border="bottom" type="primary" icon="mdi-laptop"
                >User Access Control
            </v-alert>
            <v-card-text class="pb-0">
                <v-container class="pb-0">
                    <h2>Physical Asset</h2>
                    <v-row>
                        <v-col
                            cols="4"
                            v-for="(item, key) in selected_physical_access"
                            :key="key"
                            class="pt-0 pb-0"
                        >
                            <v-checkbox
                                class="pt-0 "
                                v-model="checkboxphysicalasset"
                                :label="item.name"
                                :value="item.value"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <h3>
                        Devices
                    </h3>
                    <v-row>
                        <v-col
                            cols="4"
                            v-for="(item, key) in selected_devices"
                            :key="key"
                            class="pt-0 pb-0"
                        >
                            <v-checkbox
                                class="pt-0 "
                                :label="item.name"
                                :value="item.value"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <hr class="mb-8" />
                    <h2 class="mb-6">Software Asset</h2>
                    <h3>
                        Standard
                    </h3>
                    <v-row class="mb-6">
                        <v-col
                            cols="4"
                            v-for="(item, key) in selected_software_standard"
                            :key="key"
                            class="pt-0 pb-0"
                        >
                            <v-checkbox
                                class="pt-0 "
                                v-model="checkboxphysicalasset"
                                :label="item.name"
                                :value="item.value"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <h3>
                        Non Standard
                    </h3>
                    <v-row>
                        <v-col
                            cols="4"
                            v-for="(item,
                            key) in selected_software_non_standard"
                            :key="key"
                            class="pt-0 pb-0"
                        >
                            <v-checkbox
                                class="pt-0 "
                                :label="item.name"
                                :value="item.value"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <hr class="mb-8" />
                    <h2 class="mb-6">Application Asset</h2>
                    <h3>
                        Internal
                    </h3>
                    <v-row class="mb-6">
                        <v-col
                            cols="4"
                            v-for="(item, key) in selected_internal_app"
                            :key="key"
                            class="pt-0 pb-0"
                        >
                            <v-checkbox
                                class="pt-0"
                                v-model="checkboxphysicalasset"
                                :label="item.name"
                                :value="item.value"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <h3>
                        External
                    </h3>
                    <v-row>
                        <v-col
                            cols="4"
                            v-for="(item, key) in selected_external_app"
                            :key="key"
                            class="pt-0 pb-0"
                        >
                            <v-checkbox
                                class="pt-0"
                                :label="item.name"
                                :value="item.value"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-card v-if="radiocheckone != ''">
            <v-alert dense border="bottom" type="primary"> </v-alert>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                extarea
                                name="input-7-1"
                                label="Remark"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected_type: [
                { name: "New Hire", value: "new" },
                { name: "Transfer Department", value: "transfer" },
                { name: "Update / Change", value: "update" },
                { name: "Resign", value: "resign" },
            ],
            selected_timeatt: [
                { name: "PC", value: "pc" },
                { name: "PC & Mobile", value: "mobile" },
            ],
            selected_timeranged: [
                { name: "08.30 - 17.30", value: "08.30 - 17.30" },
                { name: "09.00 - 18.00", value: "09.00 - 18.00" },
            ],
            selected_permission: [
                { name: "Email", value: "Email" },
                { name: "Working Location Access", value: "Building" },
                { name: "User Access Control", value: "Access" },
            ],
            selected_location: [
                { name: "Srifuengfung Bldg. (Rama 4)", value: "SFF" },
                { name: "DHL Bldg. (Rama 3)", value: "DHL" },
                { name: "SVC / HUB / WFH", value: "SVC" },
                { name: "Outsite Office", value: "Outsite" },
            ],
            selected_sff_area: [
                { name: "Main", value: "Main" },
                { name: "Call Center Room", value: "Call Center" },
                { name: "Support UC Room", value: "Support UC" },
                { name: "OKI Room", value: "OKI" },
                { name: "ODM Room", value: "ODM" },
                { name: "Inventory Room", value: "Inventory" },
                { name: "Meeting Room", value: "Meeting" },
                { name: "IT Room", value: "IT" },
            ],
            selected_dhl_area: [
                { name: "Main 3rd floor.", value: "Main" },
                { name: "Admin Room", value: "Admin" },
                { name: "Bench Room", value: "Bench" },
                { name: "Store Room", value: "Store" },
            ],
            selected_access_hour: [
                { name: "24 Hour Accessible", value: "24 Hour Accessible" },
                {
                    name: "7 Day Work Time (05:00 - 20:00)",
                    value: "7 Day Work Time (05:00 - 20:00)",
                },
                {
                    name: "5 Day Work Time (05:00 - 20:00)",
                    value: "5 Day Work Time (05:00 - 20:00)",
                },
                {
                    name: "House Maid 5 Day (04:00 - 17:30)",
                    value: "House Maid 5 Day (04:00 - 17:30)",
                },
            ],
            selected_svc_area: [{ name: "Front Counter", value: "Front" }],
            selected_physical_access: [
                {
                    name: "บัตรพนักงาน / บัตรประกันสุขภาพ",
                    value: "card_acacia",
                },
                { name: "บัตรพนักงาน HP (Onsite UC)", value: "card_hp" },
                { name: "โทรศัพท์บริษัท", value: "phone" },
                { name: "Notebook บริษัท", value: "notebook" },
                { name: "เครื่องมือช่าง", value: "tools" },
            ],
            selected_devices: [
                { name: "PC", value: "pc" },
                { name: "Notebook", value: "notebook" },
                { name: "Mobile / Tablet", value: "mobile" },
            ],
            selected_software_standard: [
                { name: "Windows (OS)", value: "windows" },
                { name: "MS Anti-virus", value: "msanti" },
                { name: "MS Office - Word,Excel", value: "msoffice" },
                { name: "MS Mail", value: "msmail" },
                { name: "Acrobat PDF Reader", value: "acrobat" },
                { name: "Winzip", value: "winzip" },
                { name: "7-Zip", value: "7zip" },
                { name: "Google Chrome", value: "chrome" },
                { name: "Microsoft Edge", value: "edge" },
                { name: "Mozilla Firefox", value: "firefox" },
                { name: "Safari", value: "safari" },
                { name: "VNC Viewer", value: "vnc" },
                { name: "Teamviewer", value: "teamviewer" },
            ],
            selected_software_non_standard: [
                { name: "CD Organizer", value: "CD" },
                { name: "Line", value: "line" },
                { name: "MS Office - Project", value: "project" },
                { name: "MS Office - Visio", value: "visio" },
                { name: "Crystal report", value: "crystal" },
                { name: "File Zilla", value: "filezilla" },
                { name: "Notepad++", value: "notepad" },
                { name: "Visual Studio Code", value: "vscode" },
                { name: "Azure Data Studio", value: "azure" },
                { name: "SQL Management Studio", value: "mssql" },
                { name: ".Net Framework", value: ".net" },
            ],
            selected_internal_app: [
                { name: "Hybrid System", value: "Hybrid" },
                { name: "HR System", value: "HR" },
                { name: "HP Invoice", value: "HP" },
                { name: "Stationery", value: "Stationery" },
            ],
            selected_external_app: [
                { name: "CDAX", value: "CDAX" },
                { name: "SOMC", value: "SOMC" },
                { name: "EINSTEIN", value: "EINSTEIN" },
            ],
            radiocheckone: "",
            checkboxrequest: [],
            checkboxemail: false,
            checkboxbuilding: false,
            checkboxaccess: false,
            checklearnerid: false,
            checkboxworkstation: [],
            checkboxsrifuengfung: false,
            checkboxdhlrama3: false,
            checkboxsvc: false,
            checkboxoutsiteoffice: false,
            checkboxphysicalasset: [],
            checkboxsoftwareasset: [],
        }
    },
    methods: {
        chooserequest(val) {
            if (val == "Email") {
                if (this.checkboxemail == true) {
                    this.checkboxemail = false
                } else {
                    this.checkboxemail = true
                }
            }
            if (val == "Building") {
                if (this.checkboxbuilding == true) {
                    this.checkboxbuilding = false
                } else {
                    this.checkboxbuilding = true
                }
            }
            if (val == "Access") {
                if (this.checkboxaccess == true) {
                    this.checkboxaccess = false
                } else {
                    this.checkboxaccess = true
                }
            }
        },
        chooseworkstation(val) {
            if (val == "SFF") {
                if (this.checkboxsrifuengfung == true) {
                    this.checkboxsrifuengfung = false
                } else {
                    this.checkboxsrifuengfung = true
                }
            }
            if (val == "DHL") {
                if (this.checkboxdhlrama3 == true) {
                    this.checkboxdhlrama3 = false
                } else {
                    this.checkboxdhlrama3 = true
                }
            }
            if (val == "SVC") {
                if (this.checkboxsvc == true) {
                    this.checkboxsvc = false
                } else {
                    this.checkboxsvc = true
                }
            }
            if (val == "CW") {
                if (this.checkboxoutsiteoffice == true) {
                    this.checkboxoutsiteoffice = false
                } else {
                    this.checkboxoutsiteoffice = true
                }
            }
        },
    },
}
</script>
